var map = {
	"assets/images/relics/NIN/relic_weapon-g_w_resistance-p_w_blade.png": 4608,
	"assets/images/relics/NIN/relic_weapon-g_w_zodiac-p_w_novus.png": 9902,
	"assets/images/relics/NIN/relic_weapon-g_w_zodiac-p_w_zeta.png": 1852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5443;